import { createSlice } from '@reduxjs/toolkit';

const checkOutConfirmInfoSlice = createSlice({
  name: 'checkOutConfirm',
  initialState: { 
    checkOutConfirmIsOpen: false,
    roomNumber: '',
    checkOutBookings: [],
  }, 
  reducers: {
    setCheckOutConfirmIsOpen: (state, action) => {
      return { ...state, checkOutConfirmIsOpen: action.payload }
    },
    setCheckOutConfirmRoomNumber: (state, action) => {
      return { ...state, roomNumber: action.payload }
    },
    setCheckOutBookings: (state, action) => {
      return { ...state, checkOutBookings: action.payload }
    },
  },
});

export const { setCheckOutConfirmIsOpen, setCheckOutConfirmRoomNumber, setCheckOutBookings } = checkOutConfirmInfoSlice.actions;
export default checkOutConfirmInfoSlice.reducer;